module.exports = __webpack_public_path__ + "media/discovery-ui/assets/tab-option-video-f1b7fc17134911f98db20d130f1faf1b.svg";